module.exports = __webpack_public_path__ + "static/img/应用效果2-无盲区.fc3974e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2/应用效果2-无盲区.png
// module id = y79R
// module chunks = 0